// @ts-check
import {
  lightColorPalette,
  DropDown,
  MenuItem
} from '@linearb/linui-common';
import { Stack } from '@mui/material';
import { Body1 } from '@linearb/linui-common/typography';
import { useWizard } from 'react-use-wizard';
import { USER_ROLES } from '@linearb/linjs-common';
import { EditYourUserProfile } from './EditYourUserProfile';
import useUserProfile from 'views/root/views/home/hooks/useUserProfile';
import { useState } from 'react';
import { STEPS } from './steps.consts';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import { LBButton } from '@linearb/buzz';

/**
 * AddRoleStep component for the user profile wizard.
 * @returns {JSX.Element} A step form that allows the user to select their role
 */
function AddRoleStep() {
  const { nextStep } = useWizard();
  const { onSave, userProfileDBData, orgId, accountId } = useUserProfile();
  const roleInitialState = userProfileDBData?.role || USER_ROLES.DEVELOPER;
  const [role, setRole] = useState(roleInitialState);

  const handleChange = event => {
    setRole(event.target.value);
  };

  const handleOnNext = () => {
    onSave({ role, currentStep: STEPS.ADD_SENIORITY });
    TrackingService.logEvent(TRACKING.EVENTS.USER_PROFILE.EVENT, {
      event_type: TRACKING.EVENTS.USER_PROFILE.EVENT_TYPE.ADD_ROLE,
      user_id: accountId,
      org_id: orgId,
      role
    });
    nextStep();
  };

  return (
    <>
      <Stack direction='column'>
        <Body1 color={lightColorPalette.lbTextSubdued}>
          We're happy to see you! Let us know a bit about yourself. This will be
          used to match the best insights for your profile.
        </Body1>
        <EditYourUserProfile />
        <Body1
          color={lightColorPalette.lbTextSubdued}
          paddingTop={2}
          paddingBottom={1}
        >
          What is your role?
        </Body1>
        <DropDown
          sx={{ color: `${lightColorPalette.lbTextSubdued} !important` }}
          defaultValue={role}
          onChange={handleChange}
          MenuProps={{
            PaperProps: {
              sx: {
                zIndex: '1501 !important'
              }
            },
            sx: {
              zIndex: '1501 !important'
            }
          }}
          data-cy='user-profile-role-dropdwon'
        >
          {Object.values(USER_ROLES).map(userRole => {
            return (
              <MenuItem
                key={userRole}
                value={userRole}
                sx={{ width: '35rem !important' }}
              >
                {userRole}
              </MenuItem>
            );
          })}
        </DropDown>
      </Stack>
      <Stack direction='row' justifyContent='flex-end' paddingTop={3}>
        <LBButton
          onClick={handleOnNext}
          data-cy='user-profile-add-seniority-button'
        >
          Next: Add Seniority
        </LBButton>
      </Stack>
    </>
  );
}

export default AddRoleStep;
